import { useEffect, useId, useState } from 'react';
const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5008';
export function CompanyFilter({ value, onChange }) {
  const id = useId();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    const controller = new AbortController();
    async function load() {
      try {
        const token = localStorage.getItem('@user_token');
        if (!token) throw new Error('Faça login para consultar as empresas.');
        const response = await fetch(`${baseUrl.replace(/\/$/, '')}/api/Empresa`, { headers: { Authorization: `Bearer ${token}` }, signal: controller.signal });
        const messages = { 401: 'Sua sessão expirou. Faça login novamente.', 403: 'Você não tem permissão para consultar as empresas.', 429: 'Muitas consultas. Aguarde e tente novamente.' };
        if (!response.ok) throw new Error(messages[response.status] || 'Não foi possível carregar as empresas.');
        const result = await response.json();
        if (!Array.isArray(result)) throw new Error('Resposta inválida ao consultar as empresas.');
        if (!controller.signal.aborted) setCompanies(result);
      } catch (error) { if (!controller.signal.aborted) setError(error.message); }
      finally { if (!controller.signal.aborted) setLoading(false); }
    }
    load();
    return () => controller.abort();
  }, []);
  return <div className="rounded border border-gray-800 bg-[#161b22] px-4 py-1.5">
    <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:gap-3">
    <label htmlFor={id} className="shrink-0 text-[10px] font-bold uppercase tracking-wider text-gray-400">Empresa</label>
    <select id={id} value={value} onChange={event => onChange(event.target.value)} disabled={loading || Boolean(error) || companies.length === 0} className="w-full rounded border border-gray-700 bg-[#0d1117] px-3 py-2 text-sm text-white focus:outline-none focus:ring-2 focus:ring-blue-500 sm:max-w-md">
      <option value="">Todas as empresas</option>
      {companies.map(company => <option key={company.codigo} value={String(company.codigo)}>{company.nome_fantasia || `Empresa ${company.codigo} (nome fantasia não informado)`}</option>)}
    </select>
    </div>
    {loading && <p role="status" className="mt-2 text-xs text-gray-400">Carregando empresas...</p>}
    {error && <p role="alert" className="mt-2 text-xs text-red-300">{error}</p>}
    {!loading && !error && companies.length === 0 && <p className="mt-2 text-xs text-gray-400">Nenhuma empresa cadastrada.</p>}
  </div>;
}
